import type { Element } from "@xmpp/xml"

export async function parseHybridJsonResponse<T = unknown>(
  result: Element,
): Promise<T> {
  const jsonElement = result
    .getChild("command", "http://jabber.org/protocol/commands")
    ?.getChild("json", "urn:xmpp:json:0")

  if (!jsonElement) {
    throw new Error("No JSON response from ad-hoc command")
  }

  const envelope = JSON.parse(jsonElement.text())
  if (envelope && typeof envelope === "object" && "url" in envelope) {
    const response = await fetch(envelope.url as string)
    if (!response.ok) {
      throw new Error(`Failed to fetch hybrid JSON payload: ${response.status}`)
    }
    return (await response.json()) as T
  }

  return envelope as T
}
